import { Centered, FullScreenContainer } from '@gorila-shared-ui/components';
import { useState } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { DASHBOARD_PANELS_PAGE, GPT_DETAIL_PAGE, SESSION_404_PAGE } from '../../constants/app';
import useEffectOnce from '../../hooks/useEffectOnce';
import { useStyles } from '../../hooks/useStyles';
import { GnpKmSegurosLayout } from '../layout/GnpKmSegurosLayout';
import { DashboardPanelPage } from '../pages/DashboardPanelPage';
import Error404Page from '../pages/Error404Page';
import { GptEventPage } from '../pages/GptEventPage';
import { LoginPage } from '../pages/LoginPage';
import { MainPage } from '../pages/MainPage';
import { ServerErrorPage } from '../pages/ServerErrorPage';
import { ErrorElementBoundary } from '../shared/ErrorBoundary';

const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
    errorElement: <ErrorElementBoundary />,
  },
  {
    id: 'home',
    element: <GnpKmSegurosLayout />,
    errorElement: <ErrorElementBoundary />,
    children: [
      {
        id: DASHBOARD_PANELS_PAGE.id,
        path: DASHBOARD_PANELS_PAGE.route,
        element: <DashboardPanelPage />,
      },
      {
        id: GPT_DETAIL_PAGE.id,
        path: GPT_DETAIL_PAGE.route,
        element: <GptEventPage />,
      },
      {
        id: 'main',
        path: '/',
        element: <MainPage />,
      },
      {
        id: SESSION_404_PAGE.id,
        path: SESSION_404_PAGE.route,
        element: <Error404Page />,
      },
    ],
  },
  {
    id: '404',
    path: '/*',
    element: <Centered>404</Centered>,
  },
  {
    id: '500',
    path: '/500',
    element: <ServerErrorPage />,
  },
]);

export function AppRoutes() {
  const { classes, theme } = useStyles();
  const [loading, setLoading] = useState(true);

  useEffectOnce(() => {
    document.fonts.ready.then(() => {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    });
  });

  return (
    <FullScreenContainer>
      <RouterProvider router={router} />
      {loading && (
        <div
          className={`${classes.verticalFlex} ${classes.centeredFlex}`}
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            background: theme.colors.backgroundInversePrimary,
          }}
        >
          <img
            alt="Gorila MX"
            src="/img/login_logo.jpg"
            height={50}
            style={{
              animation: 'pulse 2s infinite',
            }}
          />
        </div>
      )}
    </FullScreenContainer>
  );
}
